import {
	AlertTriangle,
	Bell,
	Building2,
	CalendarRange,
	ClipboardList,
	FilePenLine,
	FileSpreadsheet,
	FolderCog,
	ListChecks,
	type LucideIcon,
	Megaphone,
	Network,
	RefreshCw,
	Tag,
	Tags,
	Target,
	Trophy,
	Users,
	UsersRound,
} from 'lucide-react'
import { ROUTES } from './routes'

export interface AdminMenuItem {
	/** Chave em administration.options.<id> */
	id: string
	icon: LucideIcon
	route: string
}

export interface AdminMenuGroup {
	/** Chave em administration.groups.<id> e segmento da rota /administration/menu/<id> */
	id: string
	icon: LucideIcon
	items: AdminMenuItem[]
}

/**
 * Menu da Administração agrupado por assunto, para a tela inicial não virar uma parede de cards.
 * Cada grupo abre uma subpágina com os seus itens; o acesso de cada item continua em permissions.ts.
 */
export const ADMIN_MENU_GROUPS: AdminMenuGroup[] = [
	{
		id: 'ssmaRegistry',
		icon: FolderCog,
		items: [
			{
				id: 'questionnaires',
				icon: ClipboardList,
				route: ROUTES.ADMINISTRATION.QUESTIONNAIRES,
			},
			{
				id: 'typologyRisks',
				icon: AlertTriangle,
				route: ROUTES.ADMINISTRATION.TYPOLOGY_RISKS,
			},
			{
				id: 'classifications',
				icon: Tags,
				route: ROUTES.ADMINISTRATION.CLASSIFICATIONS,
			},
			{
				id: 'customerClassifications',
				icon: Tag,
				route: ROUTES.ADMINISTRATION.CUSTOMER_CLASSIFICATIONS,
			},
			{
				id: 'ddsMonthlyThemes',
				icon: CalendarRange,
				route: ROUTES.ADMINISTRATION.DDS_MONTHLY_THEMES,
			},
		],
	},
	{
		id: 'communication',
		icon: Megaphone,
		items: [
			{
				id: 'notifications',
				icon: Bell,
				route: ROUTES.ADMINISTRATION.NOTIFICATIONS,
			},
			{
				id: 'campaigns',
				icon: ClipboardList,
				route: ROUTES.ADMINISTRATION.CAMPAIGNS,
			},
		],
	},
	{
		id: 'organization',
		icon: UsersRound,
		items: [
			{ id: 'users', icon: Users, route: ROUTES.ADMINISTRATION.USERS },
			{
				id: 'contracts',
				icon: Building2,
				route: ROUTES.ADMINISTRATION.CONTRACTS,
			},
			{
				id: 'customers',
				icon: Building2,
				route: ROUTES.ADMINISTRATION.CUSTOMERS,
			},
			{
				id: 'orgOverrides',
				icon: Network,
				route: ROUTES.ADMINISTRATION.ORG_OVERRIDES,
			},
			{
				id: 'syncProtheus',
				icon: RefreshCw,
				route: ROUTES.ADMINISTRATION.SYNC_PROTHEUS,
			},
			{
				id: 'spheraExport',
				icon: FileSpreadsheet,
				route: ROUTES.ADMINISTRATION.SPHERA_EXPORT,
			},
			{
				id: 'spheraOptions',
				icon: ListChecks,
				route: ROUTES.ADMINISTRATION.SPHERA_OPTIONS,
			},
		],
	},
	{
		id: 'goals',
		icon: Target,
		items: [
			{
				id: 'commitmentMatrix',
				icon: Target,
				route: ROUTES.ADMINISTRATION.COMMITMENT_MATRIX,
			},
			{ id: 'scoring', icon: Trophy, route: ROUTES.ADMINISTRATION.SCORING },
		],
	},
]

/** Itens usados no dia a dia que ficam direto na tela inicial, fora dos grupos */
export const ADMIN_MENU_SHORTCUTS: AdminMenuItem[] = [
	{
		id: 'fixInspection',
		icon: FilePenLine,
		route: ROUTES.ADMINISTRATION.FIX_INSPECTION,
	},
]

export const adminGroupRoute = (groupId: string) =>
	ROUTES.ADMINISTRATION.GROUP.replace(':group', groupId)

/** Para onde o "voltar" de uma tela da Administração leva: o grupo dela, ou a tela inicial */
export function adminBackRoute(route: string): string {
	const group = ADMIN_MENU_GROUPS.find((candidate) =>
		candidate.items.some((item) => item.route === route),
	)
	return group ? adminGroupRoute(group.id) : ROUTES.ADMINISTRATION.INDEX
}
